/**
 * Constants shared across Simulator components
 */

export const MESSAGES = {
  INITIAL_POSITIONS: 'Initial positions',
  PORTFOLIO_REBALANCING_SUMMARY: 'Portfolio Rebalancing Summary',
  SIMULATION_RESULTS: 'Simulation results',
  NO_MESSAGE: 'NO_MESSAGE',
};

export const STATUS_MESSAGES = {
  SIMULATION_COMPLETED: 'Simulation completed!',
  RECEIVING_REBALANCING_EVENTS: 'Receiving rebalancing events...',
  CONNECTION_FAILED: 'Connection failed. Make sure the server is running',
  PORTFOLIO_CHART_PENDING:
    'Simulation in progress — portfolio charts will appear when rebalancing data arrives.',
};
